export default __webpack_public_path__ + "static/ebook-back-34778bc21149c72cfccdb95336a0630c.png";